import "core-js/modules/es6.array.find.js";
export function shouldShowSubquestion(subQuestion, option, response) {
  // get current rating
  var rating = response.find(function (v) {
    return v.ref === option.ref;
  }); // if rating missing, do not show any subquestions

  if (!rating) {
    return false;
  } // if no conditions, return true


  var conditions = subQuestion.showIf;

  if (!conditions) {
    return true;
  } // run tests - if failed, return false
  // handle anticipated conditions


  if (conditions.aspectRatingId) {
    // if matching rating and aspectRatingIds do not match, return false
    if (rating && rating.aspectRatingId !== conditions.aspectRatingId) {
      return false;
    }
  }

  if (conditions.oppositeId) {
    // if matching rating and oppositeIds do not match, return false
    if (rating && rating.aspectRatingId !== conditions.oppositeId) {
      return false;
    }
  } // if passed all tests, return true


  return true;
}
export default {
  shouldShowSubquestion: shouldShowSubquestion
};